import React from "react";
import { ResponsiveHeroImage, Link } from "@quintype/components";
import get from "lodash/get";
import PropTypes from "prop-types";

import "./hero-image.m.css";

export const HeroImage = ({ story }) => {
  const slug = get(story, ["hero-image-s3-key"], "");
  const storySlug =
    story["story-template"] === "news-elsewhere" ? get(story, ["metadata", "reference-url"], story.slug) : story.slug;
  const fallbackImage = () => {
    return (
      <div styleName="hero-image-wrapper">
        {!slug ? (
          <div className="image">{/* fallback image yet to be added */}fallback</div>
        ) : (
          <figure>
            <ResponsiveHeroImage
              story={story}
              aspectRatio={[16, 9]}
              defaultWidth={480}
              widths={[250, 480, 640]}
              sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 98%"
              imgParams={{ auto: ["format", "compress"], fit: "max" }}
            />
          </figure>
        )}
      </div>
    );
  };

  return story ? (
    story["story-template"] === "news-elsewhere" ? (
      <a href={storySlug} target="_blank" rel="noopener noreferrer">
        {fallbackImage()}
      </a>
    ) : (
      <Link href={"/" + storySlug}>{fallbackImage()}</Link>
    )
  ) : null;
};

HeroImage.propTypes = {
  story: PropTypes.object
};
